import store from '../store';
import { useMessage, deviceType } from '@/utils';


export default function guardRouter(router) {
  router.beforeEach(function(to, form, next) {
    document.title = to.meta.title;

    // 网页可用尺寸<= 768 && 之前的运行环境是pc，这时候就执行commit 将showMobileComponent 改为移动端UI
    if (document.body.clientWidth <= 768 && !store.state.showMobileComponent) {
      store.commit('changeMobileComponent', true);
      next();
      return
    }
    if (document.body.clientWidth > 768 && store.state.showMobileComponent) {
      store.commit('changeMobileComponent', false);
      next();
      return
    }
    // 判断页面是否需要鉴权
    if(to.meta.auth && !store.state.token) {
      // 没有登录 去登录
      useMessage({message: '请先登录', type: 'error'});
      setTimeout(() => {
        // 微信环境下 跳转到微信登录页面
        if(deviceType().isWechat){
          window.location.href = 'http://wxzf.sdjys.org/wechat/openid?secret_key=StqVTlQQsF8F&uri=lingdinghu';
          return
        }
        
        next({
          path: '/login',
          query: {
            redirect: to.fullPath,
            islogin: 1,
          }
        })
      }, 2000);
      return
    }
    next();
  })
}